export const queryKeys = {
  adminMe: ['admin', 'me'] as const,
  companies: {
    all: ['admin', 'companies'] as const,
    list: (filters: {
      page: number
      limit: number
      status?: string
      search?: string
      sort?: string
      order?: string
    }) => ['admin', 'companies', 'list', filters] as const,
    detail: (id: string) => ['admin', 'companies', 'detail', id] as const,
  },
  insights: {
    all: ['admin', 'insights'] as const,
    overview: (range: string) => ['admin', 'insights', 'overview', range] as const,
  },
  loads: {
    all: ['admin', 'loads'] as const,
    list: (filters: {
      page: number
      limit: number
      owner_company_id?: string
      status?: string
      search?: string
      sort?: string
      order?: string
      include_deleted?: boolean
    }) => ['admin', 'loads', 'list', filters] as const,
  },
}
